module.exports = ".cursorPointer{\r\n    cursor: pointer;\r\n}\r\n.collect_list .card .card_content h4 {\r\n    word-break: break-all;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized-collect/authorized-collect.component.css
// module id = ./src/app/authorized-collect/authorized-collect.component.css
// module chunks = main